/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Connection status of the AWS account, Azure subscription, or GCP project.
*/
export enum AccountState {
  ACCOUNT_STATE_CONNECTED = 'CONNECTED',
  ACCOUNT_STATE_DISCONNECTED = 'DISCONNECTED',
  ACCOUNT_STATE_INSUFFICIENT_PERMISSIONS = 'INSUFFICIENT_PERMISSIONS',
  ACCOUNT_STATE_UNSPECIFIED = 'ACCOUNT_STATUS_UNSPECIFIED'
}
